// Central business constants for S.S. Cleaning Solutions
export const BUSINESS = {
  name: "S.S. Cleaning Solutions",
  shortName: "S.S. Cleaning Solutions",
  serviceType: "Residential & Commercial Cleaning",
  motto: "Reliable • Detailed • Trustworthy",
  phone: "219-455-1453",
  phoneHref: "tel:2194551453",
  smsHref: "sms:2194551453",
  email: "sscleaningsolutionsco@gmail.com",
  emailHref: "mailto:sscleaningsolutionsco@gmail.com",
  googleBusiness: "https://share.google/rBZXXj9wWTpGLPSjB",
  facebook: "https://www.facebook.com/profile.php?id=61587162193506",
  logoSrc: "/img/ss-logo-224.webp",
  logoIcon: "/img/ss-logo-192.png",
  logoOg: "https://sscleaningnwi.com/img/ss-logo-512.png",
  hours: [
    { day: "Mon – Fri", value: "Approx. 7:00 AM – 7:00 PM" },
    { day: "Sat – Sun", value: "By appointment / subject to availability" },
  ],
  tagline: "Locally owned. Detail-oriented. Trusted across Northwest Indiana.",
};

export const CLEANING_TYPES = [
  { value: "standard", label: "Standard House Cleaning" },
  { value: "deep", label: "Deep Cleaning" },
  { value: "recurring", label: "Recurring Cleaning" },
  { value: "move", label: "Move-In / Move-Out" },
  { value: "office", label: "Office Cleaning" },
  { value: "church", label: "Church Cleaning" },
  { value: "commercial", label: "Commercial Cleaning" },
];

export const SERVICES = [
  {
    slug: "standard",
    title: "Standard House Cleaning",
    icon: "Home",
    page: "/services#residential",
    blurb: "Top-to-bottom refresh of kitchens, bathrooms, floors, dusting and high-touch surfaces.",
  },
  {
    slug: "deep",
    title: "Deep Cleaning",
    icon: "Sparkles",
    page: "/services#deep-cleaning",
    blurb: "A thorough deep clean for spaces that need extra attention — baseboards, vents, build-up and more.",
  },
  {
    slug: "recurring",
    title: "Recurring Cleaning",
    icon: "Repeat",
    page: "/services#recurring",
    blurb: "Weekly, bi-weekly or monthly visits to keep your home or office consistently fresh.",
  },
  {
    slug: "move",
    title: "Move-In / Move-Out Cleaning",
    icon: "Truck",
    page: "/move-in-move-out",
    blurb: "Detailed cleaning for empty homes and rentals — inside cabinets, appliances and every corner.",
  },
  {
    slug: "office",
    title: "Office Cleaning",
    icon: "Briefcase",
    page: "/commercial-cleaning",
    blurb: "Reliable office cleaning that keeps your workspace tidy, sanitized and welcoming.",
  },
  {
    slug: "church",
    title: "Church Cleaning",
    icon: "Church",
    page: "/church-cleaning",
    blurb: "Respectful, careful cleaning of sanctuaries, classrooms and common areas your community deserves.",
  },
  {
    slug: "commercial",
    title: "Commercial Cleaning",
    icon: "Building2",
    page: "/commercial-cleaning",
    blurb: "Small commercial spaces kept presentable, professional and ready for customers.",
  },
];

export const CITIES = [
  { slug: "lake-station", name: "Lake Station, IN", featured: true },
  { slug: "hobart", name: "Hobart, IN", featured: true },
  { slug: "portage", name: "Portage, IN", featured: true },
  { slug: "gary", name: "Gary, IN", featured: true },
  { slug: "merrillville", name: "Merrillville, IN", featured: true },
  { slug: "hammond", name: "Hammond, IN", featured: true },
  { slug: "griffith", name: "Griffith, IN" },
  { slug: "highland", name: "Highland, IN" },
  { slug: "crown-point", name: "Crown Point, IN" },
  { slug: "valparaiso", name: "Valparaiso, IN" },
];

export const IMAGES = {
  hero: "/img/ss-hero-1024.webp",
  heroSmall: "/img/ss-hero-640.webp",
  livingRoom: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGJyaWdodCUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzc4OTIxMDU1fDA&ixlib=rb-4.1.0&q=85",
  teamCleaner: "/img/ss-team-800.webp",
  serviceAction: "https://images.unsplash.com/photo-1563453392212-326f5e854473?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmluZyUyMHNlcnZpY2V8ZW58MHx8fHwxNzc4OTIxMDU1fDA&ixlib=rb-4.1.0&q=85",
};

// Real S.S. Cleaning Solutions photos (uploaded by the owner)
export const REAL_PHOTOS = {
  facebookAd: "https://customer-assets.emergentagent.com/job_ss-cleaning-pro/artifacts/hjqaulg3_627547908_122102848317238739_4763794203874180105_n%20FACEBOOK%20SOCIAL%20MEDIA%20AD.jpg",
  workAreaReset: "https://customer-assets.emergentagent.com/job_ss-cleaning-pro/artifacts/5z12djoz_653053513_122114813685238739_7850210195778673444_n.jpg",
  frontCounter: "https://customer-assets.emergentagent.com/job_ss-cleaning-pro/artifacts/ywjp1qkw_654229739_122114813163238739_919422972470700167_n%20%281%29.jpg",
  workshopDetail: "https://customer-assets.emergentagent.com/job_ss-cleaning-pro/artifacts/nst0ye1r_680286725_122120868507238739_401906567086199499_n.jpg",
  beforeAfterCommercial: "https://customer-assets.emergentagent.com/job_ss-cleaning-pro/artifacts/bov5dy0k_680895757_122120868213238739_6661132647576075643_n.jpg",
};
